__turbopack_context__.v({
  "changelog": "_tYnVW_changelog",
  "changelog__notes": "_tYnVW_changelog__notes",
});
